/* Bakhoorlaïa — comportements. Reprend ceux des maquettes de Julie,
   branchés sur le panier Shopify. */
(function () {
  'use strict';

  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];

  /* ─────────── Tiroir de panier ─────────── */

  const tiroir = () => $('#tiroir');
  const voile  = () => $('#voile-panier');

  function ouvrirTiroir() {
    tiroir()?.classList.add('ouvert');
    voile()?.classList.add('ouvert');
    tiroir()?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function fermerTiroir() {
    tiroir()?.classList.remove('ouvert');
    voile()?.classList.remove('ouvert');
    tiroir()?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /** Re-rend le tiroir depuis le serveur : le panier Shopify reste la vérité. */
  async function rafraichirTiroir() {
    const r = await fetch(`${window.routes.cart_url}?section_id=tiroir-contenu`);
    if (!r.ok) return;
    const html = await r.text();
    const neuf = new DOMParser().parseFromString(html, 'text/html');
    const ancienAside = $('#tiroir');
    const neufAside = neuf.querySelector('#tiroir');
    if (ancienAside && neufAside) {
      const etaitOuvert = ancienAside.classList.contains('ouvert');
      ancienAside.innerHTML = neufAside.innerHTML;
      if (etaitOuvert) ancienAside.classList.add('ouvert');
    }
    const nb = neuf.querySelector('#tiroir-nb')?.textContent?.trim();
    if (nb !== undefined) {
      $$('.ouvre-tiroir').forEach(a => a.setAttribute('data-nb-panier', nb));
    }
    document.dispatchEvent(new CustomEvent('panier:maj'));
  }

  async function ecrirePanier(url, corps) {
    try {
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps)
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        console.warn('Panier :', err.description || r.statusText);
        return false;
      }
      await rafraichirTiroir();
      return true;
    } catch (e) {
      console.warn('Panier injoignable :', e);
      return false;
    }
  }

  const changerLigne = (cle, qte) => ecrirePanier(window.routes.cart_change_url + '.js', { id: cle, quantity: qte });
  const ajouterVariante = (id, qte) => ecrirePanier(window.routes.cart_add_url + '.js', { items: [{ id: Number(id), quantity: qte || 1 }] });

  // Ouverture par l'icône panier de l'en-tête
  document.addEventListener('click', e => {
    const ouvre = e.target.closest('.ouvre-tiroir');
    if (ouvre) { e.preventDefault(); ouvrirTiroir(); return; }
    if (e.target.closest('#fermer-tiroir')) { fermerTiroir(); return; }
    if (e.target.id === 'voile-panier') { fermerTiroir(); return; }
    if (e.target.closest('[data-ferme-tiroir]')) { fermerTiroir(); return; }
    const carte = e.target.closest('.sug-carte');
    if (carte && e.target.closest('button')) { ajouterVariante(carte.dataset.variante, 1); return; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') fermerTiroir(); });

  // Compteurs, retrait, suggestions — délégués, le tiroir étant re-rendu
  document.addEventListener('click', e => {
    const ligne = e.target.closest('.tiroir-ligne');
    if (ligne) {
      const pas = e.target.closest('[data-pas]');
      if (pas) {
        const qte = Number($('.qte', ligne).textContent) + Number(pas.dataset.pas);
        changerLigne(ligne.dataset.cle, Math.max(0, qte));
        return;
      }
      if (e.target.classList.contains('retirer')) {
        changerLigne(ligne.dataset.cle, 0);
        return;
      }
    }
    const sug = e.target.closest('.sug');
    if (sug && e.target.closest('button')) {
      ajouterVariante(sug.dataset.variante, 1);
    }
  });

  // Code promo : Shopify applique un code par /discount/<code>
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-promo]');
    if (!form) return;
    e.preventDefault();
    const code = form.querySelector('input')?.value.trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code)
      + '?redirect=' + encodeURIComponent(window.routes.cart_url);
  });

  // Formulaires d'ajout au panier : on intercepte pour ouvrir le tiroir
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.id === 'formulaire-produit') return;
    e.preventDefault();
    const bouton = form.querySelector('[type="submit"]');
    bouton?.setAttribute('disabled', '');
    try {
      const r = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (r.ok) { await rafraichirTiroir(); ouvrirTiroir(); }
      else {
        const err = await r.json().catch(() => ({}));
        const zone = form.querySelector('[data-erreur-panier]');
        if (zone) zone.textContent = err.description || 'Ajout impossible.';
      }
    } finally {
      bouton?.removeAttribute('disabled');
    }
  });

  /* ─────────── Carrousel de témoignages ─────────── */

  function monterTemoignages(racine) {
    const bloc  = $('.temoignage', racine) || $('#temoignage', racine);
    const puces = $$('.puce', racine);
    const source = $('[data-avis]', racine);
    if (!bloc || !source) return;

    let avis;
    try { avis = JSON.parse(source.textContent); } catch { return; }
    if (!avis.length) return;

    let idx = 0, minuteur = null;
    const peindre = i => {
      const a = avis[i];
      const et = $('#t-etoiles', racine); if (et) et.textContent = '★'.repeat(a.n) + '☆'.repeat(5 - a.n);
      const tx = $('#t-texte', racine);   if (tx) tx.textContent = '« ' + a.t + ' »';
      const nm = $('#t-nom', racine);     if (nm) nm.textContent = a.nom;
      puces.forEach((p, k) => p.classList.toggle('actif', k === i));
    };
    const aller = i => {
      bloc.classList.add('sort');
      setTimeout(() => {
        idx = (i + avis.length) % avis.length;
        peindre(idx);
        bloc.classList.remove('sort');
      }, 500);
    };
    const lancer  = () => { if (!reduit) minuteur = setInterval(() => aller(idx + 1), 6500); };
    const stopper = () => clearInterval(minuteur);

    peindre(0);
    lancer();
    puces.forEach(p => p.addEventListener('click', () => { stopper(); aller(Number(p.dataset.i)); lancer(); }));
    bloc.addEventListener('mouseenter', stopper);
    bloc.addEventListener('mouseleave', lancer);
  }

  /* ─────────── Piste de coffrets ─────────── */

  function monterPiste(racine) {
    const piste   = $('[data-piste]', racine);
    const suivant = $('[data-piste-suivant]', racine);
    if (!piste) return;
    const carte = () => {
      const p = piste.querySelector(':scope > *');
      return p ? p.getBoundingClientRect().width + 24 : 300;
    };
    const auBout = () => piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
    const majFleche = () => { if (suivant) suivant.hidden = auBout(); };

    let rythme = null;
    const avancer = () => piste.scrollTo({ left: auBout() ? 0 : piste.scrollLeft + carte(), behavior: 'smooth' });
    const lancer  = () => { if (!reduit && piste.scrollWidth > piste.clientWidth + 8) rythme = setInterval(avancer, 5000); };
    const stopper = () => clearInterval(rythme);

    majFleche();
    lancer();
    piste.addEventListener('scroll', majFleche, { passive: true });
    window.addEventListener('resize', majFleche);
    piste.addEventListener('mouseenter', stopper);
    piste.addEventListener('mouseleave', lancer);
    piste.addEventListener('touchstart', stopper, { passive: true });
    suivant?.addEventListener('click', () => {
      piste.scrollBy({ left: carte(), behavior: 'smooth' });
      stopper(); lancer();
    });
  }


  /* ─────────── Fiche produit ─────────── */

  function monterProduit(racine) {
    const form = $('#formulaire-produit', racine);
    if (!form) return;
    const cta     = $('#cta-panier', racine);
    const choisie = $('[data-variante-choisie]', racine);
    const formats = $$('.formats-achat button', racine);
    const offres  = $$('.offres input[type="radio"]', racine);
    const cases   = $$('.ajout-rapide input[type="checkbox"]', racine);
    const barre   = $('#barre-achat');
    const libelle = cta?.dataset.libelle || 'Ajouter au panier';
    const monnaie = window.monnaie || { format: '{{amount_with_comma_separator}} €' };

    const euro = c => monnaie.format.replace('{{amount_with_comma_separator}}', (c / 100).toFixed(2).replace('.', ','))
                                    .replace('{{amount}}', (c / 100).toFixed(2));

    // Base d'achat : l'offre cochée, sinon le format de variante actif.
    let prixBase = 0, qteBase = 1, idBase = choisie?.value || '';

    const lireBase = () => {
      const offre = offres.find(r => r.checked);
      if (offre) {
        prixBase = Number(offre.dataset.prix) || 0;
        qteBase  = Number(offre.dataset.quantite) || 1;
        idBase   = offre.dataset.variante || idBase;
      } else {
        const actif = $('.formats-achat button.actif', racine) || formats[0];
        prixBase = Number(actif?.dataset.prix) || 0;
        qteBase  = 1;
        idBase   = actif?.dataset.variante || idBase;
      }
      if (choisie && idBase) choisie.value = idBase;
    };

    const majTotal = () => {
      const cochees = cases.filter(c => c.checked);
      // prixBase est déjà le total de l'offre, quantité comprise ; sans offre, c'est le prix unitaire.
      const affiche = prixBase + cochees.reduce((s, c) => s + Number(c.dataset.prix), 0);
      if (cta && !cta.disabled) {
        const n = cochees.length + qteBase;
        cta.innerHTML = (n > 1 ? (window.traductions?.ajouter_n || 'Ajouter {{ n }} articles au panier').replace('{{ n }}', n) : libelle)
                      + ' — <span data-total>' + euro(affiche) + '</span>';
      }
      const bp = barre?.querySelector('.prix');
      if (bp) bp.textContent = euro(affiche);
    };

    // Offres : une seule active, le total suit.
    offres.forEach(r => r.addEventListener('change', () => {
      $$('.offres .offre', racine).forEach(o => o.classList.toggle('actif', o.contains(r) && r.checked));
      lireBase();
      majTotal();
    }));

    // Repli : le sélecteur de variantes historique.
    formats.forEach(b => b.addEventListener('click', () => {
      formats.forEach(x => { x.classList.remove('actif'); x.setAttribute('aria-checked', 'false'); });
      b.classList.add('actif'); b.setAttribute('aria-checked', 'true');
      lireBase();
      majTotal();
    }));

    cases.forEach(c => c.addEventListener('change', majTotal));
    lireBase();
    majTotal();

    // Galerie : la vignette cliquée devient la grande image.
    const grand = $('.galerie .grand img', racine);
    const vignettes = $$('.vignettes button', racine);
    vignettes.forEach(b => b.addEventListener('click', () => {
      if (!grand || !b.dataset.grand) return;
      grand.src = b.dataset.grand;
      if (b.dataset.grandSrcset) grand.srcset = b.dataset.grandSrcset;
      if (b.dataset.alt !== undefined) grand.alt = b.dataset.alt;
      vignettes.forEach(x => x.classList.remove('actif'));
      b.classList.add('actif');
    }));

    // Ajout groupé : l'offre choisie avec sa quantité + les ventes additionnelles.
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!choisie?.value) return;
      const items = [{ id: Number(choisie.value), quantity: qteBase }]
        .concat(cases.filter(c => c.checked).map(c => ({ id: Number(c.dataset.variante), quantity: 1 })));
      cta?.setAttribute('disabled', '');
      const zone = $('[data-erreur-panier]', form);
      try {
        const r = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (r.ok) { if (zone) zone.textContent = ''; await rafraichirTiroir(); ouvrirTiroir(); }
        else { const err = await r.json().catch(() => ({})); if (zone) zone.textContent = err.description || 'Ajout impossible.'; }
      } catch (err) { if (zone) zone.textContent = 'Panier injoignable.'; }
      finally { cta?.removeAttribute('disabled'); }
    }, { capture: true });

    // Barre d'achat collante : visible dès que le bouton principal est sorti par le haut.
    if (barre && cta) {
      const suivre = () => {
        const visible = cta.getBoundingClientRect().bottom < 0;
        barre.classList.toggle('visible', visible);
        barre.setAttribute('aria-hidden', String(!visible));
      };
      suivre();
      window.addEventListener('scroll', suivre, { passive: true });
      $('[data-barre-ajouter]', barre)?.addEventListener('click', () => form.requestSubmit());
    }
  }



  /* ─────────── Menu mobile ─────────── */

  function monterMenuMobile() {
    const bouton = $('header .burger');
    const panneau = $('#menu-mobile');
    const voile = $('.voile-menu');
    if (!bouton || !panneau) return;
    const basculer = ouvrir => {
      panneau.classList.toggle('ouvert', ouvrir);
      voile?.classList.toggle('ouvert', ouvrir);
      panneau.setAttribute('aria-hidden', String(!ouvrir));
      bouton.setAttribute('aria-expanded', String(ouvrir));
      document.body.style.overflow = ouvrir ? 'hidden' : '';
      if (ouvrir) panneau.querySelector('a')?.focus(); else bouton.focus();
    };
    bouton.addEventListener('click', () => basculer(!panneau.classList.contains('ouvert')));
    $$('[data-ferme-menu]').forEach(e => e.addEventListener('click', () => basculer(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && panneau.classList.contains('ouvert')) basculer(false); });
    window.matchMedia('(min-width: 641px)').addEventListener('change', e => { if (e.matches) basculer(false); });
  }

  /* ─────────── Bandeau de recherche ─────────── */

  function monterRecherche() {
    const bouton  = $('header .ouvre-recherche');
    const panneau = $('#bandeau-recherche');
    if (!bouton || !panneau) return;
    const form    = $('.rb-champ', panneau);
    const champ   = $('[data-champ-recherche]', panneau);
    const sortie  = $('[data-suggestions]', panneau);
    // routes.root_url vaut « / » en français mais « /en » sans barre finale
    // sur les autres marchés : on la normalise avant de composer l'appel.
    const brut    = form?.dataset.racine || '/';
    const racine  = brut.endsWith('/') ? brut : brut + '/';

    const basculer = ouvrir => {
      panneau.hidden = !ouvrir;
      bouton.setAttribute('aria-expanded', String(ouvrir));
      if (ouvrir) champ.focus();
      else { champ.value = ''; sortie.hidden = true; sortie.innerHTML = ''; }
    };

    bouton.addEventListener('click', e => {
      e.preventDefault();
      basculer(panneau.hidden);
    });
    $$('[data-ferme-recherche]', panneau).forEach(b => b.addEventListener('click', () => basculer(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panneau.hidden) basculer(false); });
    document.addEventListener('click', e => {
      if (panneau.hidden) return;
      if (!panneau.contains(e.target) && !bouton.contains(e.target)) basculer(false);
    });

    // Suggestions : rendues par la section, donc mêmes cartes et même devise.
    let minuteur, requete;
    const chercher = async terme => {
      const url = racine + 'search/suggest?q=' + encodeURIComponent(terme)
                + '&resources[type]=product&resources[limit]=6'
                + '&resources[options][unavailable_products]=last'
                + '&section_id=suggestions-recherche';
      requete?.abort?.();
      requete = new AbortController();
      try {
        const html = await fetch(url, { signal: requete.signal }).then(r => r.text());
        const rendu = new DOMParser().parseFromString(html, 'text/html')
                        .querySelector('.shopify-section')?.innerHTML || '';
        sortie.innerHTML = rendu;
        sortie.hidden = rendu.trim() === '';
      } catch (err) {
        if (err.name !== 'AbortError') { sortie.hidden = true; sortie.innerHTML = ''; }
      }
    };

    champ.addEventListener('input', () => {
      const terme = champ.value.trim();
      clearTimeout(minuteur);
      if (terme.length < 2) { requete?.abort?.(); sortie.hidden = true; sortie.innerHTML = ''; return; }
      minuteur = setTimeout(() => chercher(terme), 220);
    });
  }

  /* ─────────── Rotation générique (bande de réassurance) ─────────── */

  function monterRotation(racine) {
    $$('[data-rotation]', racine || document).forEach(bande => {
      const cases = $$(':scope > *', bande);
      if (cases.length < 2 || bande.dataset.montee === '1') return;
      bande.dataset.montee = '1';
      const duree = (Number(bande.dataset.duree) || 4) * 1000;
      let rang = 0, minuteur;
      const suivant = () => {
        rang = (rang + 1) % cases.length;
        cases.forEach((c, n) => c.classList.toggle('actif', n === rang));
      };
      const lancer = () => { arreter(); minuteur = setInterval(suivant, duree); };
      const arreter = () => clearInterval(minuteur);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) arreter(); else lancer();
      });
      lancer();
    });
  }

  /* ─────────── En-tête posé sur le hero ─────────── */

  function monterEnteteSurHero() {
    const entete = $('header.sur-hero');
    if (!entete) return;
    const mesurer = () => document.documentElement.style
      .setProperty('--h-entete', entete.offsetHeight + 'px');
    mesurer();
    window.addEventListener('resize', mesurer);

    // Elle redevient pleine dès qu'on quitte le haut du hero.
    const hero = $('.hero');
    const seuil = () => (hero ? hero.offsetHeight - entete.offsetHeight : 40);
    let dernier = null;
    const suivre = () => {
      const posee = window.scrollY > seuil();
      if (posee !== dernier) { entete.classList.toggle('pose', posee); dernier = posee; }
    };
    suivre();
    window.addEventListener('scroll', suivre, { passive: true });
  }

  /* ─────────── Bandeau défilant ─────────── */

  function monterTicker() {
    $$('[data-ticker].defile').forEach(barre => {
      const messages = $$(':scope > span', barre);
      if (messages.length < 2) return;
      const duree = (Number(barre.dataset.duree) || 5) * 1000;
      let rang = 0, minuteur;
      const montrer = i => {
        messages.forEach((m, n) => m.classList.toggle('actif', n === i));
      };
      const suivant = () => { rang = (rang + 1) % messages.length; montrer(rang); };
      const lancer = () => { arreter(); minuteur = setInterval(suivant, duree); };
      const arreter = () => clearInterval(minuteur);
      // On suspend au survol et quand l'onglet passe à l'arrière-plan.
      barre.addEventListener('mouseenter', arreter);
      barre.addEventListener('mouseleave', lancer);
      barre.addEventListener('focusin', arreter);
      barre.addEventListener('focusout', lancer);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) arreter(); else lancer();
      });
      lancer();
    });
  }

  /* ─────────── Fenêtre d'inscription à la lettre ─────────── */

  function monterFenetreLettre() {
    const voile = $('[data-fenetre-lettre]');
    if (!voile) return;
    const CLE = 'bkl-lettre-vue';
    const editeur = window.Shopify && window.Shopify.designMode;
    const repos = Number(voile.dataset.repos || 30) * 86400000;
    const delai = Number(voile.dataset.delai || 6) * 1000;

    const lu = () => { try { return Number(localStorage.getItem(CLE)) || 0; } catch (e) { return 0; } };
    const noter = () => { try { localStorage.setItem(CLE, String(Date.now())); } catch (e) {} };

    let minuteur;
    const fermer = () => {
      voile.classList.remove('ouverte');
      if (voile.dataset.toujours !== '1') noter();
      document.body.style.overflow = '';
      setTimeout(() => { voile.hidden = true; }, 350);
    };
    const ouvrir = () => {
      voile.hidden = false;
      // Un reflux forcé plutôt qu'une frame : dans un onglet en arrière-plan,
      // requestAnimationFrame ne se déclenche pas et la fenêtre resterait
      // transparente jusqu'au retour de la visiteuse.
      void voile.offsetWidth;
      voile.classList.add('ouverte');
      document.body.style.overflow = 'hidden';
      $('input[type="email"]', voile)?.focus();
    };

    $$('[data-ferme-fenetre]', voile).forEach(b => b.addEventListener('click', fermer));
    voile.addEventListener('click', e => { if (e.target === voile) fermer(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !voile.hidden) fermer();
    });
    // Une inscription réussie vaut fermeture définitive.
    if ($('.merci-fenetre', voile)) noter();

    const toujours = voile.dataset.toujours === '1';
    if (editeur) { ouvrir(); return; }
    if (!toujours && Date.now() - lu() < repos) return;
    minuteur = setTimeout(ouvrir, delai);
    // Sortie de page : on propose avant de perdre la visiteuse.
    document.addEventListener('mouseout', function sortie(e) {
      if (e.clientY > 0 || e.relatedTarget) return;
      document.removeEventListener('mouseout', sortie);
      clearTimeout(minuteur);
      if (voile.hidden) ouvrir();
    });
  }

  /* ─────────── Copier le lien d'un article ─────────── */

  function monterCopier(racine) {
    $$('[data-copier]', racine || document).forEach(bouton => {
      if (bouton.dataset.montee === '1') return;
      bouton.dataset.montee = '1';
      bouton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(bouton.dataset.copier);
          bouton.classList.add('copie');
          setTimeout(() => bouton.classList.remove('copie'), 1600);
        } catch (e) { /* le navigateur refuse le presse-papiers, on n'insiste pas */ }
      });
    });
  }

  /* ─────────── Sommaire des pages légales ─────────── */

  function monterSommaire(racine) {
    $$('[data-legal]', racine || document).forEach(page => {
      const nav = $('[data-sommaire]', page);
      const texte = $('.legal-texte', page);
      if (!nav || !texte || nav.dataset.montee === '1') return;
      nav.dataset.montee = '1';
      const titres = $$('h2', texte);
      if (titres.length < 3) { nav.hidden = true; return; }

      const liste = $('ol', nav);
      const liens = titres.map((h, i) => {
        if (!h.id) h.id = 'section-' + (i + 1);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        liste.appendChild(li);
        return a;
      });

      // Le lien de la section lue se marque au passage.
      if (!('IntersectionObserver' in window)) return;
      const veilleur = new IntersectionObserver(entrees => {
        entrees.forEach(e => {
          if (!e.isIntersecting) return;
          const i = titres.indexOf(e.target);
          liens.forEach((a, n) => a.classList.toggle('actif', n === i));
          /* Sur mobile le sommaire est une bande qui glisse : on amène
             l'entrée courante dans le champ, sinon la marque active se
             perd hors écran. */
          const piste = liste.parentElement;
          if (piste && piste.scrollWidth > piste.clientWidth + 4) {
            const a = liens[i];
            if (a) piste.scrollTo({ left: Math.max(a.offsetLeft - 16, 0), behavior: 'smooth' });
          }
        });
      }, { rootMargin: '-132px 0px -70% 0px' });
      titres.forEach(h => veilleur.observe(h));
    });
  }

  /* ─────────── Montage + cycle de vie de l'éditeur ─────────── */

  function monter(racine) {
    $$('[data-section-type="temoignages"]', racine).forEach(monterTemoignages);
    $$('[data-section-type="coffrets"]', racine).forEach(monterPiste);
    $$('[data-section-type="produit"]', racine).forEach(monterProduit);
    monterRotation(racine);
  }


  /* ═══ BARRE DE PROGRESSION DES PISTES ═══
     Les pistes qui glissent masquent la barre de défilement native pour
     rester propres, mais on perd alors le seul repère indiquant qu'il y
     a une suite et où l'on en est. On repose une barre discrète sous
     chaque piste réellement débordante. Purement décorative : la piste
     reste défilable au doigt, la barre ne fait que refléter. */
  const PISTES = '.senteurs.piste-mobile, .etapes-photo, .coffrets-piste, .galerie.defilante, .article-aussi-grille, .occasions';

  function monterJauges(racine) {
    $$(PISTES, racine || document).forEach(piste => {
      if (piste.dataset.jauge) return;
      piste.dataset.jauge = '1';

      const jauge = document.createElement('div');
      jauge.className = 'piste-jauge';
      jauge.setAttribute('aria-hidden', 'true');
      const barre = document.createElement('span');
      jauge.appendChild(barre);
      piste.insertAdjacentElement('afterend', jauge);

      let attente = false;
      const peindre = () => {
        attente = false;
        const debord = piste.scrollWidth - piste.clientWidth;
        // Rien à faire glisser : la barre n'a rien à raconter.
        if (debord <= 4) { jauge.style.display = 'none'; return; }
        jauge.style.display = '';
        const part = piste.clientWidth / piste.scrollWidth;
        const avance = piste.scrollLeft / debord;
        barre.style.width = (part * 100).toFixed(2) + '%';
        barre.style.transform = 'translateX(' + (avance * (100 / part - 100)).toFixed(2) + '%)';
      };

      piste.addEventListener('scroll', () => {
        if (attente) return;
        attente = true;
        requestAnimationFrame(peindre);
      }, { passive: true });

      if (typeof ResizeObserver === 'function') new ResizeObserver(peindre).observe(piste);
      window.addEventListener('resize', peindre);
      peindre();
      // Les images arrivent après : la largeur de la piste change.
      $$('img', piste).forEach(i => { if (!i.complete) i.addEventListener('load', peindre, { once: true }); });
    });
  }


  /* ═══ COMPTEURS DE LA BANDE DE CHIFFRES ═══
     Le nombre monte de zéro à sa valeur quand la bande entre à l'écran,
     une seule fois. On garde la valeur finale dans le HTML : si le
     script ne tourne pas, ou si la personne a demandé moins
     d'animations, le chiffre juste est déjà là. */
  function monterCompteurs(racine) {
    const cibles = $$('[data-compteur]', racine || document);
    if (!cibles.length) return;

    const sobre = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const compter = element => {
      const fin = parseInt(element.dataset.compteur, 10);
      if (!isFinite(fin) || sobre) return;
      // L'unité est un enfant : on ne réécrit que le nœud de texte.
      const texte = element.firstChild;
      if (!texte || texte.nodeType !== 3) return;

      const duree = 900;
      const depart = performance.now();
      const pas = maintenant => {
        const avance = Math.min((maintenant - depart) / duree, 1);
        // Départ vif, arrivée freinée.
        const doux = 1 - Math.pow(1 - avance, 3);
        texte.nodeValue = String(Math.round(fin * doux));
        if (avance < 1) requestAnimationFrame(pas);
        else texte.nodeValue = String(fin);
      };
      texte.nodeValue = '0';
      requestAnimationFrame(pas);
    };

    if (typeof IntersectionObserver !== 'function') return;
    const guetteur = new IntersectionObserver((entrees, obs) => {
      entrees.forEach(entree => {
        if (!entree.isIntersecting) return;
        obs.unobserve(entree.target);
        compter(entree.target);
      });
    }, { threshold: 0.6 });

    cibles.forEach(c => {
      if (c.dataset.compte) return;
      c.dataset.compte = '1';
      guetteur.observe(c);
    });
  }


  /* ═══ BANDE D'INSPIRATION ═══
     Choisir une photo l'agrandit et fait venir son mot à gauche. Sans
     script, la première est déjà marquée dans le HTML et les liens
     restent cliquables. */
  function monterInspiration(racine) {
    $$('[data-section-type="inspiration"]', racine || document).forEach(section => {
      if (section.dataset.montee === '1') return;
      section.dataset.montee = '1';

      const piste = $('[data-inspiration-piste]', section);
      const points = $('[data-inspiration-points]', section);
      if (!piste) return;

      const items = $$('[data-inspiration-item]', section);
      const textes = $$('[data-inspiration-texte]', section);
      if (items.length < 2) return;

      let courant = 0;
      /* Sur téléphone la choisie n'est pas en tête mais en deuxième
         position : il reste ainsi une carte à sa gauche, et on la
         centre par le défilement. Sur ordinateur elle ouvre la piste. */
      const etroit = () => window.matchMedia('(max-width: 900px)').matches;

      const choisir = (i, animer) => {
        const precedent = courant;
        courant = i;

        /* On relève les positions avant de réordonner, puis on rejoue
           l'écart en transform : la carte glisse visiblement de sa
           place vers la première au lieu d'y sauter. */
        const decalage = etroit() ? 1 : 0;
        const avant = animer ? items.map(li => li.getBoundingClientRect().left) : null;

        items.forEach((li, n) => {
          const actif = n === i;
          li.classList.toggle('actif', actif);
          /* La choisie prend la première place, les autres suivent en
             tournant : il reste toujours des photos derrière elle,
             même sur la dernière. */
          li.style.order = String((n - i + decalage + items.length) % items.length);
          const b = li.querySelector('.inspiration-vue');
          if (b) b.setAttribute('aria-current', String(actif));
        });
        textes.forEach((t, n) => t.classList.toggle('actif', n === i));
        pastilles.forEach((b, n) => b.setAttribute('aria-current', String(n === i)));
        if (decalage) {
          const actif = items[i];
          piste.scrollLeft = actif.offsetLeft - piste.offsetLeft
            - (piste.clientWidth - actif.offsetWidth) / 2;
        } else {
          piste.scrollLeft = 0;
        }

        if (!avant) return;
        const apres = items.map(li => li.getBoundingClientRect().left);
        items.forEach((li, n) => {
          const rang = (n - i + decalage + items.length) % items.length;
          const rangAvant = (n - precedent + decalage + items.length) % items.length;
          li.style.transition = 'none';
          /* Celles qui repassent derrière traverseraient toute la piste
             pour rejoindre la fin : on ne les anime pas, elles prennent
             leur place directement. Seules celles qui se décalent vers
             la gauche glissent — c'est ce mouvement-là que l'œil suit,
             et rien ne survole les autres. */
          if (rang > rangAvant) { li.style.transform = ''; return; }
          const ecart = avant[n] - apres[n];
          li.style.transform = ecart ? 'translateX(' + ecart + 'px)' : '';
        });
        /* Reflow forcé plutôt qu'une frame d'animation : si la frame ne
           venait pas, les cartes resteraient décalées. */
        void piste.offsetWidth;
        items.forEach(li => {
          li.style.transition = 'transform .55s cubic-bezier(.33,.1,.2,1)';
          li.style.transform = '';
        });
      };

      const pastilles = items.map((li, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', String(i + 1));
        b.setAttribute('aria-current', String(i === 0));
        b.addEventListener('click', () => choisir(i, true));
        if (points) points.appendChild(b);
        return b;
      });

      items.forEach((li, i) => {
        li.querySelector('.inspiration-vue')?.addEventListener('click', () => {
          // Cliquer sur celle déjà choisie fait passer à la suivante.
          choisir(i === courant ? (i + 1) % items.length : i, true);
        });
      });

      choisir(0, false);
      /* Le passage d'une largeur à l'autre change l'arrangement. */
      window.matchMedia('(max-width: 900px)').addEventListener('change', () => choisir(courant, false));
    });
  }

  document.addEventListener('DOMContentLoaded', () => { monter(document); monterMenuMobile(); monterRecherche(); monterFenetreLettre(); monterTicker(); monterEnteteSurHero(); monterRotation(); monterSommaire(); monterCopier(); monterJauges(); monterCompteurs(); monterInspiration(); });
  document.addEventListener('shopify:section:load', e => { monter(e.target); if (e.target.querySelector('header .burger')) { monterMenuMobile(); monterRecherche(); monterEnteteSurHero(); } if (e.target.querySelector('[data-fenetre-lettre]')) monterFenetreLettre(); if (e.target.querySelector('[data-ticker]')) monterTicker(); monterJauges(e.target); monterCompteurs(e.target); monterInspiration(e.target); });

  window.rafraichirTiroir = rafraichirTiroir;
})();
